/** Numeric comparison operator used by `FieldValidation.requiredWhen`'s legacy op (see LEGACY_OP_MAP in evaluateFieldRules.ts). Values are a persisted config/wire slug — deliberately lowercase, not key-cased. */
export enum HaulerFieldComparisonOpEnum {
  Gte = 'gte',
  Lte = 'lte',
  Gt = 'gt',
  Lt = 'lt',
  Eq = 'eq',
}
